const { default: axios } = require("axios");

adjust_death_adt_values = (cover, coberturas) => {
  cover.monthly = parseFloat(cover.valorCapital) * parseFloat(cover.tax);

  const outrasCoberturasSum = coberturas
    .filter((x) => x.order > 1 && x.valorCapital > 0)
    .reduce((n, { monthly }) => n + monthly, 0);
  if (outrasCoberturasSum + cover.monthly < 30) {
    cover.monthly = 30 - outrasCoberturasSum;
    cover.valorCapital = Math.round(cover.monthly / parseFloat(cover.tax), 2);
  }
};

async function saveSessionInfo(data) {
  try {
    const clickId = localStorage.getItem("sessionId");
    const url = "https://globusesteiraback.azurewebsites.net/api/";
    // const url = "http://localhost:3007/api/"
    await axios.post(`${url}loja/set-info-session?clickId=${clickId}`, data);
  } catch (error) {
    console.log(error);
  }
}

module.exports = {
  adjust_death_adt_values,
  saveSessionInfo,
};
